module.exports = __webpack_public_path__ + "static/media/me.d7ca1856.svg";